import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Row } from 'reactstrap';
import { PageNames } from '../../../utilities/constValues';
import { clientConfig } from '../../../utilities/configService';
import { useOidc } from '@axa-fr/react-oidc';

const isPageSecure = (pageName: PageNames): boolean => {
    const registeredPages = clientConfig?.CONTENT?.REGISTERED_USERS_PAGES || [];
    return registeredPages.some(p => p.PageName.toLowerCase() === pageName.toLowerCase());
};

export const SiteNavigation = () => {
    const { isAuthenticated } = useOidc();
    const [activeFleetEstimatorLocation, setActiveFleetEstimatorLocation] = useState(false);
    const [activeResourcesLocation, setActiveResourcesLocation] = useState(false);

    const [fleetEstimatorDropdownOpen, setFleetEstimatorDropdownOpen] = useState(false);
    const toggleFleetEstimatorDropdown = async () => {
        setFleetEstimatorDropdownOpen(state => !state);
    }

    const [resourceDropdownOpen, setResourceDropdownOpen] = useState(false);
    const toggleResourceDropdown = async () => {
        setResourceDropdownOpen(state => !state);
    }

    const location = useLocation();

    useEffect(() => {
        if (location && (location.pathname.indexOf("ViewEstimate") >= 0
            || location.pathname.indexOf("CreateFleet") >= 0
            || location.pathname.indexOf("ViewFleets") >= 0
            || location.pathname.indexOf("AddVehicleSets") >= 0
            || location.pathname.indexOf("EditVehicleSets") >= 0
            || location.pathname.indexOf("EditFleet") >= 0)) {
            setActiveFleetEstimatorLocation(true);
        }
        else {
            setActiveFleetEstimatorLocation(false);
        }

        if (location && (location.pathname.indexOf("ChargingStationLocator") >= 0
            || location.pathname.indexOf("VehicleCatalog") >= 0
            || location.pathname.indexOf("FundingSources") >= 0
            || location.pathname.indexOf("ElectrificationBasics") >= 0
            || location.pathname.indexOf("ElectricVehicles") >= 0
            || location.pathname.indexOf("ElectricVehicleSupplyEquipment") >= 0
            || location.pathname.indexOf("NewsAndEvents") >= 0)){
            setActiveResourcesLocation(true);
        }
        else {
            setActiveResourcesLocation(false);
        }

    }, [location]);


    return (
        <div className="container-fluid siteNavigation">
            <Row>
                <Col md="12">
                    <div className="siteNavTabs">
                        <div className="siteNav">
                            <Row>
                                <Col sm="auto" className="siteNavItem">
                                    <NavLink className="homepageLink" key="Home" to="/" >
                                        <span>Home</span>
                                    </NavLink>
                                </Col>
                                {(!isPageSecure(PageNames.ProgramOverview) || isAuthenticated) &&
                                <Col sm="auto" className="siteNavItem">
                                    <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} key="Overview" to="/ProgramOverview" >
                                        <span>Program Overview</span>
                                    </NavLink>
                                </Col>
                                }
                                {(!isPageSecure(PageNames.FleetEstimator) || isAuthenticated) &&
                                    <Col sm="auto" className="siteNavItem">
                                        <Dropdown id="fleetEstimatorDropDown" className={(activeFleetEstimatorLocation ? "fleetEstimatorDropDown siteNavDropDown lg ddActive" : "fleetEstimatorDropDown siteNavDropDown lg")} direction="down"
                                            isOpen={fleetEstimatorDropdownOpen} toggle={toggleFleetEstimatorDropdown}>
                                            <DropdownToggle caret>
                                                <div className="centeringDiv">Fleet Estimator</div>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                {(!isPageSecure(PageNames.CreateFleet) || isAuthenticated) &&
                                                <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} to="/CreateFleet">
                                                    <DropdownItem>Create a Fleet</DropdownItem>
                                                </NavLink>
                                                }
                                                {(!isPageSecure(PageNames.ViewFleets) || isAuthenticated) &&
                                                <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} to="/ViewFleets">
                                                    <DropdownItem>View My Fleets</DropdownItem>
                                                </NavLink>
                                                }
                                            </DropdownMenu>
                                        </Dropdown>
                                    </Col>
                                }
                                {(!isPageSecure(PageNames.ElectrificationBasics) || isAuthenticated) &&
                                    <Col sm="auto" className="siteNavItem">
                                        <Dropdown id="resourceDropDown" className={(activeResourcesLocation ? "resourceDropDown siteNavDropDown lg ddActive" : "resourceDropDown siteNavDropDown sm")} direction="down" isOpen={resourceDropdownOpen} toggle={toggleResourceDropdown}>
                                            <DropdownToggle caret>
                                                <div className="centeringDiv">Electrification Resources</div>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                {(!isPageSecure(PageNames.ChargingStationLocator) || isAuthenticated) &&
                                                <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} to="/ChargingStationLocator">
                                                    <DropdownItem>Charger Locator</DropdownItem>
                                                </NavLink>
                                                }
                                                {(!isPageSecure(PageNames.VehicleCatalog) || isAuthenticated) &&
                                                <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} to="/VehicleCatalog">
                                                    <DropdownItem>Electric Vehicle Catalog</DropdownItem>
                                                </NavLink>
                                                }
                                                {(!isPageSecure(PageNames.FundingSources) || isAuthenticated) &&
                                                <NavLink className={({ isActive, isPending }) => isPending ? "pending dividerItem" : isActive ? "active dividerItem" : "dividerItem"} to="/FundingSources">
                                                    <DropdownItem>Funding Sources</DropdownItem>
                                                </NavLink>
                                                }
                                                {(!isPageSecure(PageNames.ElectrificationBasics) || isAuthenticated) &&
                                                <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} key="Basics" to="/ElectrificationBasics">
                                                    <DropdownItem>Electrification Basics</DropdownItem>
                                                </NavLink>
                                                }
                                                {(!isPageSecure(PageNames.ElectricVehicles) || isAuthenticated) &&
                                                <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} to="/ElectricVehicles">
                                                    <DropdownItem>EV Fundamentals</DropdownItem>
                                                </NavLink>
                                                }
                                                {(!isPageSecure(PageNames.ElectricVehicleSupplyEquipment) || isAuthenticated) &&
                                                <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} to="/ElectricVehicleSupplyEquipment">
                                                    <DropdownItem>EV Supply Equipment</DropdownItem>
                                                </NavLink>
                                                }
                                                {(!isPageSecure(PageNames.NewsAndEvents) || isAuthenticated) &&
                                                <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} key="NewsEvents" to="/NewsAndEvents">
                                                    <DropdownItem>News &amp;&nbsp;Events</DropdownItem>
                                                </NavLink>
                                                }
                                            </DropdownMenu>
                                        </Dropdown>
                                    </Col>
                                }
                                {(!isPageSecure(PageNames.ContactUs) || isAuthenticated) &&
                                <Col sm="auto" className="siteNavItem">
                                    <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} key="ContactUs" to="/ContactUs" >
                                        <span>Contact Us</span>
                                    </NavLink>
                                </Col>
                                }
                            </Row>

                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
}
